import React, { useEffect } from 'react';
import { Col, Row, Form } from "react-bootstrap";
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { object, string, date } from 'yup';
import { sub } from 'date-fns';
import Button from '../../Helpers/Buttons/CovrButton';
import { KeyboardDatePickerInput, RadioInput, SelectInput } from '../../Helpers/Inputs';
import BudgetAmounts from '../../Helpers/Lists/BudgetAmounts/BudgetAmounts';
import Refresh from '@material-ui/icons/Refresh';

import '../../Quoters/Quoter.scss';

export default function QuoteForm(props) {

  const handleBirthdateChange = date => {
    setValue("birthdate", date);
    props.quoteFields.setBirthdate(date);
  }

  const handleGenderChange = event => {
    setValue("gender", event.target.value);
    props.quoteFields.setGender(event.target.value);
  }

  const handleTobaccoChange = event => {
    setValue("tobacco", event.target.value);
    props.quoteFields.setTobacco(event.target.value);
  }

  const handleHealthClassChange = event => {
    setValue("healthClass", event.target.value);
    props.quoteFields.setHealthClass(event.target.value);
  }

  const handleBudgetAmountChange = event => {
    setValue("budgetAmount", event.target.value);
    props.quoteFields.setBudgetAmount(event.target.value);
  }

  const handleTermLengthChange = event => {
    setValue("termLength", event.target.value);
    props.quoteFields.setTermLength(event.target.value);
  }

  const validationSchema = object().shape({
    birthdate: date('Birthdate is required')
      .typeError('Birthdate is required in the format MM/DD/YYYY')
      .required('Birthdate is required in the format MM/DD/YYYY')
      .min(sub(new Date(), { years: props.product.maxAge, days: 1 }), 'The maximum age for this product is ' + props.product.maxAge)
      .max(sub(new Date(), { years: props.product.minAge }), 'The minimum age for this product is ' + props.product.minAge),
    gender: string().required('Gender is required'),
    tobacco: string().required('Tobacco Use is required'),
    healthClass: string().required('Health Class is required'),
    budgetAmount: string().required('BudgetAmount is required'),
    termLength: string().required('Years of Coverage is required'),
  })

  const { register, handleSubmit, errors, setValue, triggerValidation } = useForm({
    validationSchema: validationSchema,
    mode: 'onBlur',
    reValidateMode: 'onChange',
  });

  const onSubmit = data => {
    props.getQuote();
  }

  const getFormIsValid = async () => {
    const valid = await triggerValidation();
    return valid;
  }

  useEffect(() => {
    if (getFormIsValid()) {
      props.getQuote();
    }
  }, [props.quoteFields.birthdate, props.quoteFields.gender, props.quoteFields.tobacco, props.quoteFields.healthClass, props.quoteFields.termLength, props.quoteFields.budgetAmount]);


  useEffect(() => {
    register({ name: "birthdate" });
    register({ name: "gender" });
    register({ name: "tobacco" });
    register({ name: "healthClass" });
    register({ name: "budgetAmount" });
    register({ name: "termLength" });
  }, [])

  useEffect(() => {
    setValue("gender", props.quoteFields.gender);
    setValue("tobacco", props.quoteFields.tobacco);
    setValue("healthClass", props.quoteFields.healthClass);
    setValue("budgetAmount", props.quoteFields.budgetAmount);
    setValue("termLength", props.quoteFields.termLength);
  }, [register])

  return (
    <Col lg={4}>
      <Form className="quote-form shadow-sm" onSubmit={handleSubmit(onSubmit)} >
        <h2 className="title">Estimate Insurance Cost</h2>

        <Form.Group>
          <KeyboardDatePickerInput
            value={props.quoteFields.birthdate}
            maxDate={sub(new Date(), { years: props.product.minAge })}
            minDate={sub(new Date(), { years: props.product.maxAge })}
            onChange={(event, date) => handleBirthdateChange(date)}
            name="birthdate"
            inputRef={register}
            errors={errors.birthdate}
            label="Date of Birth"
          />
        </Form.Group>

        <Row className="radio-buttons">
          <Col xs={6}>
            <Form.Group>
              <RadioInput
                label="Gender"
                name="gender"
                inputRef={register}
                onChange={handleGenderChange}
                errors={errors.gender}
                value={props.quoteFields.gender}
                radios={[{ value: "M", label: "Male" }, { value: "F", label: "Female" }]}
              />
            </Form.Group>
          </Col>
          <Col xs={6}>
            <Form.Group>
              <RadioInput
                label="Tobacco"
                name="tobacco"
                inputRef={register}
                onChange={handleTobaccoChange}
                errors={errors.tobacco}
                value={props.quoteFields.tobacco}
                radios={[{ value: "no", label: "Never used" }, { value: "yes", label: "Have used" }]}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group>
          <SelectInput
            name="healthClass"
            value={props.quoteFields.healthClass}
            onChange={handleHealthClassChange}
            label="Health Class"
            errors={errors.healthClass}
            selectOptions={props.product.healthClasses}
          />
        </Form.Group>

        <Form.Group>
          <SelectInput
            name="budgetAmount"
            value={props.quoteFields.budgetAmount}
            onChange={handleBudgetAmountChange}
            label="Budget Amount"
            errors={errors.budgetAmount}
            selectOptions={BudgetAmounts()}
          />
        </Form.Group>

        <Form.Group>
          <SelectInput
            name="termLength"
            value={props.quoteFields.termLength}
            onChange={handleTermLengthChange}
            label="Years of Coverage"
            errors={errors.termLength}
            selectOptions={props.product.coverageLengths}
          />
        </Form.Group>

        <div className="center d-flex justify-content-center">
          <Button name={<span><Refresh /> Refresh Estimates</span>} loading={props.loading}></Button>
        </div>

      </Form>
    </Col>
  )

}



// WEBPACK FOOTER //
// ./src/components/Tools/BudgetBasedQuoter/QuoteForm.js